import BaseService from './base-service';

const resource = `/auth/v1`;
export default {
  login(email, password, type) {
    return BaseService.post(`${resource}/login`, {
      email,
      password,
      type,
    });
  },
  register({ email, password, state }) {
    return BaseService.post(`${resource}/signup`, {
      email,
      password,
      state,
    });
  },
  verifyAccount(token) {
    return BaseService.get(`${resource}/verify/${token}`);
  },
  passwordResetRequest(email) {
    return BaseService.post(`${resource}/password-reset-request`, { email });
  },
  passwordReset(token, password) {
    return BaseService.post(`${resource}/password-reset`, {
      token,
      password,
    });
  },
};
